import Vue from 'vue'
import { AclInstaller, AclCreate, AclRule } from 'vue-acl'
import router from '@/router'

Vue.use(AclInstaller)

let initialRole = 'COMMERCIAL'

const userInfo = JSON.parse(localStorage.getItem('userInfo'))
if (userInfo && userInfo.role) initialRole = userInfo.role

// Use lower ACL role in router. PermissionCodes allowed in each user are checked after - allowed or not depending user.
// If ACL role is set to higher role than user, permissionCodes can't be checked -> it goes directly to unauthorized.
// Using Permissions over Role (a role may not have a permission from its role, but it may have a higher one)
export default new AclCreate({
  initial  : initialRole,
  notfound : '/e-prevision/not-authorized',
  router,
  acceptLocalRules : true,
  globalRules: {
    superAdmin  : new AclRule('SUPER_ADMIN').generate(),
    admin  : new AclRule('ADMIN').or('SUPER_ADMIN').generate(),
    viewAdmin  : new AclRule('ADMIN').or('SUPER_ADMIN').or('ADMIN_CONSULTING').generate(),
    editor : new AclRule('ADMIN').or('SUPER_ADMIN').or('ADMIN_CONSULTING').or('COMMERCIAL_DIRECTOR').or('CLAIMS_DIRECTOR').or('ACCOUNTING_DIRECTOR').generate(),
    // Cualquier rol: el acceso real lo dan los viewPermissions de cada ruta (router.beforeEach).
    // Con una lista de roles, cada rol nuevo (CAC, CAC_DIRECTOR...) se quedaba en "no autorizado".
    user : new AclRule('*').generate()
  }
})